module.exports = __webpack_public_path__ + "static/media/favicon-reed902.d9833f00.ico";